// extracted by mini-css-extract-plugin
export default {"table-with-search-container":"TableWithSearchTemplate_table-with-search-container__k9jpm"};